import React from 'react';
import { MapPin, UtensilsCrossed, Bike } from 'lucide-react';
import { howItWorks } from '../mock/mock';

const iconMap = { MapPin, UtensilsCrossed, Bike };

const HowItWorks = () => {
  return (
    <section className="bg-secondary/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">Come funziona</h2>
          <p className="mt-3 text-muted-foreground">Ordinare con Italian Fast Delivery è semplice e veloce. In soli 3 passi il tuo pasto è in viaggio.</p>
        </div>
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {howItWorks.map((step, i) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={i} className="relative text-center">
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-white shadow-md">
                  <Icon className="h-9 w-9 text-primary" />
                </div>
                <div className="absolute top-0 left-1/2 -translate-x-[60px] flex h-7 w-7 items-center justify-center rounded-full bg-primary text-sm font-bold text-white">
                  {i + 1}
                </div>
                <h3 className="mt-5 font-display font-bold text-xl text-foreground">{step.title}</h3>
                <p className="mt-2 text-muted-foreground max-w-xs mx-auto">{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
